export { setOwner } from '@ember/application';